import DatePicker from "react-widgets/DatePicker";
import React from "react";

const DateTimeInput = (props) => {
  const updateDate = (date) => {
    console.log(date);
    props.setDate(date);
  };

  React.useEffect(() => {
    props.setDate(new Date());
  }, []);

  return (
    <DatePicker
      style={{ width: 450, fontSize: 15 }}
      defaultValue={new Date()}
      min={new Date()}
      date={props.date}
      onChange={updateDate}
    />
  );
};

export default DateTimeInput;
